module.exports = __webpack_public_path__ + "img/5985811.jpg";